import React from "react";
import { withStyles } from "@mui/styles";
import { Button } from "@mui/material";

import FormDescription from "../../../components/formDescription/FormDescription";

const styles = (theme) => ({
  section: { width: "100%", backgroundColor: "#fff" },
  textSection: { marginBottom: 20 },
});

function SetupStripeForm({ classes, stripeUrl, isSetup }) {
  return (
    <div className={classes.section}>
      {isSetup ? (
        <>
          <FormDescription>
            <div className={classes.textSection}>
              <strong>✅ Stripe is connected</strong>
              <div style={{ marginTop: 10 }}>
                Your club can accept card payments, Apple Pay and Google Pay.
              </div>
            </div>
          </FormDescription>

          <Button
            variant="contained"
            href="https://dashboard.stripe.com/"
            target="_blank"
            rel="noreferrer"
            component="a"
            sx={{ backgroundColor: "#47d45a", "&:hover": { backgroundColor: "#2fa83f" } }}
          >
            Open Stripe Dashboard
          </Button>
        </>
      ) : (
        <>
          <FormDescription>
            <div className={classes.textSection}>
              <div style={{ marginBottom: 10 }}>
                Stripe allows your club to accept card payments, Apple Pay and
                Google Pay.
              </div>
              <div style={{ marginBottom: 10 }}>
                You’ll be guided through account creation if needed.
              </div>
            </div>
          </FormDescription>

          <Button
            variant="contained"
            href={stripeUrl}
            component="a"
            sx={{ backgroundColor: "#47d45a", "&:hover": { backgroundColor: "#2fa83f" } }}
          >
            Setup Stripe
          </Button>
        </>
      )}
    </div>
  );
}

export default withStyles(styles)(SetupStripeForm);
